import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { BdcContentModule } from './bdc/bdc-content.module'

const components = []

const services = [
  //
]

const modules = [BdcContentModule]

@NgModule({
  imports: [SharedModule, CommonModule, ...modules],
  declarations: [...components],
  exports: [...components, ...modules],
  providers: [...services],
})
export class ChannelContentModule {}
